"use strict";
/*
 * Novicell master
 * Use this file to call functions in other files, on document ready, window.resize etc.
 */
var cl = console.log.bind(console);
var novicell = novicell || {};
var projectName = projectName || {};
var ES6Promise = ES6Promise || {};

// Document ready
document.addEventListener("DOMContentLoaded", function() {
    svg4everybody(); // Fix SVG spritemap in IE/Edge
    ES6Promise.polyfill();
    novicell.validate.init(); // Init Validation
    novicell.inputMasking.init(); //Init input masking
    novicell.slider.init();
    novicell.cookieInfo.init();
    novicell.navigation.init();
    novicell.videooverlay.init();
    novicell.tabs.init();
    novicell.search.init();
    novicell.stickyNav.run();
    novicell.accordionReadMoreOnMobile.init();
    novicell.featureComparison.init();
    novicell.highlightedFeaturesOverlay.init();
    novicell.oTrainingList.init();
    novicell.productFilters.init();
    novicell.addRemoveButtons.init();
    novicell.checkout.init();
    novicell.productPagePrices.init();
    novicell.newslistShowAll.init();
    novicell.cookieListFormatting.init();

    //  var elementToClick = document.querySelector('#a-logo__menu');
    //  var event = document.createEvent('HTMLEvents');
    // event.initEvent('touchstart', true, false);
    // elementToClick.dispatchEvent(event);
});

window.addEventListener(
    "load",
    function() {
        novicell.productImageSlider.init();
        novicell.anchorLinks.init();
    },
    false
);

window.addEventListener(
    "scroll",
    novicell.debounce(novicell.stickyNav.run, 250)
);
window.addEventListener(
    "resize",
    novicell.debounce(novicell.oTrainingList.setTextHeight, 250)
);
window.addEventListener(
    "resize",
    novicell.debounce(novicell.accordionReadMoreOnMobile.recalcAll, 250)
);
